
import barba from '@barba/core';


export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            this.run()
        })
     
        barba.hooks.after((data) => {
            this.run()
        });
    }
    run () {
        const p1 = document.querySelector("#particles-1")
        const p2 = document.querySelector("#particles-2")
        
        const params =  {"particles":{"number":{"value":115,"density":{"enable":true,"value_area":800}},"color":{"value":"#b9b9b9"},"shape":{"type":"circle","stroke":{"width":0,"color":"#000000"},"polygon":{"nb_sides":5},"image":{"src":"img/github.svg","width":100,"height":100}},"opacity":{"value":0.4734885849793636,"random":false,"anim":{"enable":false,"speed":1,"opacity_min":0.1,"sync":false}},"size":{"value":4.008530152163807,"random":true,"anim":{"enable":false,"speed":29.23311787442754,"size_min":0.8120310520674316,"sync":false}},"line_linked":{"enable":true,"distance":176.3753266952075,"color":"#c8c8c8","opacity":0.26456299004281125,"width":0.9620472365193136},"move":{"enable":true,"speed":4.810236182596568,"direction":"none","random":false,"straight":false,"out_mode":"out","bounce":false,"attract":{"enable":false,"rotateX":561.194221302933,"rotateY":1200}}},"interactivity":{"detect_on":"canvas","events":{"onhover":{"enable":false,"mode":"repulse"},"onclick":{"enable":true,"mode":"push"},"resize":true},"modes":{"grab":{"distance":400,"line_linked":{"opacity":1}},"bubble":{"distance":400,"size":40,"duration":2,"opacity":8,"speed":3},"repulse":{"distance":200,"duration":0.4},"push":{"particles_nb":4},"remove":{"particles_nb":2}}},"retina_detect":true}
        if(p1){
            particlesJS("particles-1",params);
        }
        if(p2){
            particlesJS("particles-2",params);
        }
        
    }
}